import React from 'react';
import { cn } from '@/utils/styles';

export interface CircularProgressIndicatorProps
  extends React.HTMLAttributes<HTMLDivElement> {
  progress: number; // Progress percentage (0 to 100)
  size?: number; // Size in pixels, defaults to 80
  strokeWidth?: number; // Stroke width, defaults to 6
  showText?: boolean; // Whether to show progress text in center, defaults to true
  color?: string; // Progress color, defaults to green
}

export function CircularProgressIndicator({
  progress,
  size = 80,
  strokeWidth = 6,
  showText = true,
  color = '#009E82',
  className,
  ...rest
}: CircularProgressIndicatorProps) {
  const normalizedProgress = Math.min(100, Math.max(0, progress));
  
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (normalizedProgress / 100) * circumference;

  return (
    <div
      {...rest}
      className={cn('relative inline-flex items-center justify-center', className)}
      style={{ width: size, height: size }}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={normalizedProgress}
      aria-label={`Progress: ${normalizedProgress}%`}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="transform -rotate-90"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#14646429"
          strokeWidth={strokeWidth}
          fill="none"
        />
        
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-300 ease-out"
        />
      </svg>
    </div>
  );
} 